/**
 * View
 */
import AutoSuggest from 'uikit-autosuggest';
import Promise from 'promise-polyfill';
import Config from '../Config';
import Dialog from '../Dialog';
import Template from './Template';
import Util from '../Util';

const REG_TAG_STR = /[^가-힣ㄱ-ㅎㅏa-zA-Z0-9\s\u318D\u119E\u11A2\u2022\u2025a\u00B7\uFE55]/gi;

const REG_TAG_STR_REGIST = /[^가-힣ㄱ-ㅎㅏ\a-zA-Z0-9]/gi;

const ENTER_KEY = 13;

const SPACE_KEY = 32;

const BACKSPACE_KEY = 8;

const DELETE_KEY = 46;

const LEFT_KEY = 37;

const RIGHT_KEY = 39;

class Tag {
  // 추천 태그 등록 여부 flag
  public isPlusTagAdded: boolean = false;

  // 추천 태그 보기 알림 팝업 노출 여부 flag
  public isRecmdLayerFlag: any = false;

  public tagCookieName: string = 'TAG_RECOMMAND_DISABLED';

  private recmdKey: string = '';

  private dialogRecommand: Dialog;

  private maxItemsCount: number = 10;

  private maxTextLength: number = 20;

  private backSpace: number = 0;

  private $editor: any;

  private $tagList: any;

  private $tagItems: any;

  private preTags: any = [];

  private selectedItem: string = 'is-selected';

  private tagInput: string = 'tag-input';

  private tagItems: string = 'tag-items';

  private tagClose: string = 'tag-delete';

  private editorTagItems: string = 'fr-tag-items';

  private suggest: any;

  private editor: any;

  private tagSequence: any = [];

  private oldContents: string = '';

  private legacyPlusTags: any = [];

  constructor() {
    this.dialogRecommand = new Dialog(
      {
        id: 'tagRecommand',
        msg: {
          header: '태그 자동등록 기능을 해제하시겠습니까?',
          body: '언제든 ON 상태로 다시 변경 가능합니다.',
          ok: '자동등록 기능 해제',
          cancel: '취소'
        }
      },
      () => {
        Util.setCookie(this.tagCookieName, 1, '/');
        jQuery('.co-btn-recommand').toggleClass('is-active');
        this.dialogRecommand.hide();
      },
      () => {
        this.dialogRecommand.hide();
      },
      () => {
        this.dialogRecommand.hide();
      }
    );
  }

  /**
   * view
   */
  public getAttachedTag(data: any) {
    if (!data || !data.userTags || data.userTags.length === 0) {
      return;
    }

    let _arr = [];

    jQuery('.view-body').after(Template.tagList());

    for (let i = 0; i < data.userTags.length; i++) {
      _arr.push(Template.tagItemsView(data.userTags[i]));
    }

    jQuery('.tag-list').append(_arr.join(''));
  }

  /**
   * write
   */
  public initWrite(editor: any) {
    this.editor = editor;
    this.$editor = jQuery('#froala-editor');
    this.$editor.after(Template.tagList());
    this.$tagList = jQuery('.tag-list');
    this.preTags = this.$editor
      .find(`.${this.editorTagItems}`)
      .text()
      .trim()
      .split('#')
      .splice(1);
    this.addInput();
    this.autoSuggest();
    this.setEditorTagMaxLength();
    this.addEvents();
    this.addObserver();
  }

  public setItems(data: any) {
    if (!data || !data.userTags || data.userTags.length === 0) {
      return;
    }

    let _data = data.userTags;
    let _arr: any = [];

    _data.forEach((value: any) => {
      _arr.push({ tag: value, isPlusTag: false });
    });

    this.addItem(_arr);
  }

  public getTags() {
    interface Tags {
      userTags: any;
      plusTags: any;
    }
    let tags: Tags = {
      userTags: [],
      plusTags: []
    };

    this.$tagItems = jQuery(`.${this.tagItems}`);

    if (this.$tagItems && this.$tagItems.length >= 0) {
      for (let i = 0; i < this.$tagItems.length; i++) {
        let $target = jQuery(this.$tagItems[i]);
        let _text = $target.text().trim();

        if ($target.hasClass('is-plus')) {
          tags.plusTags.push(_text);
        }
        tags.userTags.push(_text);
      }
    }

    return tags;
  }

  public getRecmdKey() {
    return this.recmdKey;
  }

  public getTagLength() {
    return jQuery(`.${this.tagItems}`).length;
  }

  private addInput() {
    jQuery('.wrap-tag').append(Template.tagInput());
    if (!!Util.getCookie(this.tagCookieName)) {
      jQuery('.co-btn-recommand').removeClass('is-active');
    }
  }

  public addItem(data: any) {
    // 최대 등록 개수 제한: 10개
    // 중복 문자열이 있는 경우 등록하지 않음.
    // 태그 입력 후 input 초기화.
    // 추천 태그를 통해 입력했을 경우 UI 차별화.
    //
    // data type.
    // {
    //   tags: string;
    //   isPlustTag: boolean;
    //   seq: number;
    // }
    if (data.length <= 0) return;

    const _tags = this.getTags();
    let _tmp: any = [];
    let _length = this.getTagLength();

    // 최대 등록 개수 제한
    if (_length >= this.maxItemsCount) {
      alert(Config.L10N.tag_max_count);
      return;
    }

    Array.prototype.forEach.call(data, (value: any) => {
      // 에디터에서 등록된 태그의 # 문자열 제거
      let _t = value.tag.indexOf('#') === -1 ? value.tag : value.tag.replace('#', '');

      // 공백제거, 특수문자 제거
      _t = _t.replace(REG_TAG_STR_REGIST, '').substr(0, 20);

      if (_t.length > 0 && !this.isStringEqual(_tags.userTags, _t) && _length < this.maxItemsCount) {
        _tmp.push(Template.tagItems(_t, value.isPlusTag, value.seq));
        _length++;
      }
    });

    this.$tagList.append(_tmp.join(''));
    this.setEditorTagMaxLength();
  }

  // 중복 문자열 비교
  private isStringEqual(a: any, b: any) {
    if (!a) return;

    if (a.indexOf(b) === -1) {
      return false;
    } else {
      return true;
    }
  }

  private deleteItem(t?: any) {
    const $deleteTarget = t ? jQuery(t.get(0)) : jQuery(`.${this.selectedItem}`);

    $deleteTarget.remove();

    this.backSpace = 0;
    this.setEditorTagMaxLength();

    if ($deleteTarget.attr('data-tag-seq')) {
      this.editor.deleteTagByIdx(Number($deleteTarget.data('tag-seq')));
    }
  }

  private setEditorTagMaxLength() {
    let _length = this.getTagLength();
    this.editor.setTagMaxLength(this.maxItemsCount - _length);
  }

  public getRecmdTags() {
    return new Promise((resolve: any, reject: any) => {
      const _recmdTags: any = {
        title: String(jQuery('#title').val()),
        content: this.editor.getSubmitContents().replace(/(<([^>]+)>)/gi, ''),
        userTags: this.getTags().userTags.concat(this.legacyPlusTags)
      };

      $.post({
        url: Config.tagRecmd,
        contentType: 'application/json',
        data: JSON.stringify(_recmdTags)
      })
        .done((data: any) => {
          resolve(data);
        })
        .fail( (error: any) => {
          reject(error);
        });
    });
  }

  public setRecmdTags(data: any, callback?: any) {
    const _data = data;
    const _finalTags = _data.final_tags ? _data.final_tags : '';
    this.recmdKey = data && data.recmdKey ? data.recmdKey : '';

    let _plusTagAddedCount = 0;
    let _arr: any = [];

    _finalTags.forEach((value: any) => {
      let _type = value.type;
      let _original = value.original.replace(/\s/g, '');
      let _tag = value.tag.replace(/\s/g, '');

      // 추천 태그 중복 여부 체크 및 개수 제한
      if (_plusTagAddedCount < this.maxItemsCount) {
        // 추천 태그가 entity 타입인 경우 original 항목을 추가로 등록한다.
        if (_type === 'entity' && _tag !== _original && !this.isStringEqual(this.legacyPlusTags, _original)) {
          _arr.push({
            tag: _original,
            isPlusTag: true
          });
          this.legacyPlusTags.push(_original);
          _plusTagAddedCount++;
        }

        // 추천 태그 데이터를 이미 등록된 태그와 비교한다.
        // 중복된 태그가 없는 경우 태그를 등록한다.
        if (!this.isStringEqual(this.legacyPlusTags, _tag)) {
          _arr.push({
            tag: _tag,
            isPlusTag: true
          });
          this.legacyPlusTags.push(_tag);
          _plusTagAddedCount++;
        }
      }
    });

    if (callback) {
      callback(_arr);
    } else {
      return _arr;
    }
  }

  public setRecmdMarkup(data: any) {
    if (!!data.length) {
      this.addItem(data);
    }
  }

  public inputFocus() {
    jQuery(`.${this.tagInput}`).focus();
  }

  private inputReset() {
    jQuery(`.${this.tagInput}`).val('');
  }

  private autoSuggest() {
    this.suggest = new AutoSuggest();
    this.suggest.init({
      selector: '#tagAutoSuggest',
      size: 5,
      apiUrl: Config.tagSearch,
      submitCallback: (query: string) => this.autoSuggestSubmit(query)
    });
  }

  private autoSuggestSubmit(query: string) {
    this.beforeAddItem(query, false);
  }

  private beforeAddItem(_tag: string, _isPlusTag: boolean) {
    const _data = {
      tag: _tag,
      isPlusTag: _isPlusTag
    };
    let _arr: any = [];
    _arr.push(_data);
    this.addItem(_arr);
    this.inputReset();
    this.inputFocus();
  }

  private itemShift(index: number) {
    if (!jQuery(`.${this.tagItems}`).length) return;

    let $currentItem = jQuery(`.${this.selectedItem}`);

    this.backSpace = 1;

    if (!!$currentItem.length) {
      // move left
      if (index < 0 && !!$currentItem.prev().length) {
        $currentItem.removeClass(this.selectedItem);
        $currentItem.prev().addClass(this.selectedItem);
      }

      // move right
      if (index > 0 && !!$currentItem.next().length) {
        $currentItem.removeClass(this.selectedItem);
        $currentItem.next().addClass(this.selectedItem);
      }
    } else {
      jQuery(`.${this.tagItems}`)
        .last()
        .addClass(this.selectedItem);
    }
  }

  private addEvents() {
    jQuery('body').on('focus', `.${this.tagInput}`, () => {
      // this.getRecommendTags();
      if (!Util.getParams().articleId &&
          !this.isPlusTagAdded &&
          Config.usePlusTag &&
          !!jQuery('#title').val() && this.editor.getSubmitContents() !== '<div data-contents-type="text"></div>') {
        this.getRecmdTags()
          .then((data: any) => this.setRecmdTags(data))
          .then((data: any) => this.setRecmdMarkup(data))
          .then(() => {
            this.isPlusTagAdded = true;
          })
          .catch((err: any) => {
            return;
          });
      }
    });

    // 추천태그 자동 등록 버튼
    if( Config.usePlusTag ) {
      jQuery('body').on('click', '.co-btn-recommand', evt => {
        if (!Util.getCookie(this.tagCookieName)) {
          this.dialogRecommand.show();
        } else {
          jQuery('.co-btn-recommand').addClass('is-active');
          Util.setCookie(this.tagCookieName, 1, '/', -1);
        }
      });
    }

    jQuery('body').on('paste', `.${this.tagInput}`, (evt: any) => {
      evt.preventDefault();
      return false;
    });

    jQuery('body').on('keyup', `.${this.tagInput}`, (evt: any) => {
      const _keyCode = evt.keyCode ? evt.keyCode : evt.which;
      const $input = jQuery(`.${this.tagInput}`);
      const $item = jQuery(`.${this.tagItems}`);
      let _value = String($input.val());

      // 키 입력 제한
      if (REG_TAG_STR.test(_value)) {
        evt.preventDefault();
        let _v = _value.replace(REG_TAG_STR_REGIST, '');
        $input.val(_v);
        return false;
      }

      if (_value.length <= 0) {
        if (_keyCode === LEFT_KEY) {
          this.itemShift(-1);
        }

        if (_keyCode === RIGHT_KEY) {
          this.itemShift(1);
        }

        // 입력 내용이 없을 때 삭제 처리
        if (_keyCode === BACKSPACE_KEY || _keyCode === DELETE_KEY) {
          if (this.backSpace === 0) {
            $item
              .removeClass(this.selectedItem)
              .last()
              .addClass(this.selectedItem);
          }
          this.backSpace++;
          if (this.backSpace === 2) {
            this.deleteItem();
          }
        }
      } else {
        // 글 입력 시 삭제 카운트 초기화
        $item.removeClass(this.selectedItem);
        this.backSpace = 0;

        // enter, space 키 입력
        // 마지막 문자열이 공백인 경우( for android )
        if (_keyCode === ENTER_KEY || _keyCode === SPACE_KEY || _value.substr(_value.length - 1) === ' ') {
          this.beforeAddItem(_value, false);
          return;
        }
      }

      // 글자 수 제한
      if (_value.length > this.maxTextLength) {
        const _val = _value.substring(0, this.maxTextLength);
        $input.val(_val);
      }
    });

    // input
    jQuery('body').on('click', '.wrap-tag_surface', (evt: any) => {
      evt.preventDefault();
      this.inputFocus();
    });

    // tag select
    jQuery('body').on('click', `.${this.tagItems}`, (evt: any) => {
      evt.preventDefault();
      const target = evt.target.className === 'tag-items' ? evt.target : jQuery(evt.target).parent(`.${this.tagItems}`);
      jQuery(`.${this.tagItems}`).removeClass(this.selectedItem);
      jQuery(target).addClass(this.selectedItem);
      jQuery('#deleteTagInput').focus();
    });

    // delete
    jQuery('body').on('click', `.${this.tagClose}, .${this.selectedItem}`, (evt: any) => {
      evt.preventDefault();
      let _target = $(evt.target).parents(`.${this.tagItems}`);
      this.deleteItem(_target);
    });

    jQuery('#deleteTagInput').on('keydown', (evt: any) => {
      const _keyCode = evt.keyCode ? evt.keyCode : evt.which;

      if (_keyCode === BACKSPACE_KEY) {
        this.deleteItem();
        this.inputFocus();
      } else if (_keyCode === LEFT_KEY) {
        this.itemShift(-1);
      } else if (_keyCode === RIGHT_KEY) {
        this.itemShift(1);
      } else {
        return false;
      }
    });

    setTimeout(() => {
      jQuery('.tag-tooltip').fadeOut();
    }, 3000);
  }

  // 에디터로 입력받은 태그의 sequence 비교
  private diffSequence(currentSequence: any) {
    let arr: any = [];
    let diffArr: any = [];
    const oldSequence = this.tagSequence;
    if (!oldSequence) {
      this.tagSequence = currentSequence;
      return;
    }

    for (let i = 0; i < oldSequence.length; i++) {
      arr[oldSequence[i]] = true;
    }

    for (let i = 0; i < currentSequence.length; i++) {
      if (arr[currentSequence[i]]) {
        delete arr[currentSequence[i]];
      } else {
        arr[currentSequence[i]] = true;
      }
    }

    for (var k in arr) {
      diffArr.push(k);
    }

    this.tagSequence = currentSequence;
    return diffArr;
  }

  private addObserver() {
    this.editor.onTag.add((data: any) => {
      let _diff: any = [];
      const _seq: any = [];
      const _tmp: any = [];

      if (!data) {
        $(`.tag-items[data-tag-seq]`).remove();
        return;
      }

      // 삭제. seq 비교해서 없는 seq는 삭제함.
      Array.prototype.forEach.call(data, (value: any) => {
        _seq.push(value.seq);
      });
      _diff = this.diffSequence(_seq);
      _diff.forEach((v: any) => {
        $(`.tag-items[data-tag-seq=${v}]`).remove();
        this.setEditorTagMaxLength();
      });

      // 추가, 수정
      Array.prototype.forEach.call(data, (value: any) => {
        let $target = $(`.tag-items[data-tag-seq=${value.seq}]`);

        if ($target.length !== 0) {
          // 수정
          let _tag = value.tag
            .replace(REG_TAG_STR, '')
            .replace(/\s/g, '')
            .substr(0, 20);

          if (this.isStringEqual(this.getTags().userTags, _tag)) {
            return;
          } else {
            $target.find('.text').text(_tag);
          }
        } else {
          // 추가
          if (this.getTagLength() >= this.maxItemsCount) {
            return;
          }
          _tmp.push(value);
          this.addItem(_tmp);
        }
      });
    });
  }
}

export default Tag;
